<template>
  <div>
    <merge-invoice-file-checking-dialog
      :visible.sync="checkingDialog.visible"
      :row-data="checkingDialog.rowData"
      :show-next="checkingDialog.showNext"
      @next="continueHandle"
    />
  </div>
</template>

<script>
import MergeInvoiceFileCheckingDialog from './CheckingDialog'
import URL from '@/api/urlTranslator'
import { mergeInvoiceFile, checkMergeInvoiceFile } from '@/api/clearing/invoice'
import { submitDataByPost } from '@/utils/commonUtil'

export default {
  name: 'MergeInvoiceFileWindow',
  components: { MergeInvoiceFileCheckingDialog },
  data() {
    return {
      noinvoicepdf: '',
      sendRoleMailAddress: '',
      checkingDialog: {
        visible: false,
        rowData: [],
        existFileInvoices: [],
        showNext: false
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, invoices) {
      if (uiInstruction.instructionParamJson) {
        this.noinvoicepdf = uiInstruction.instructionParamJson.noinvoicepdf || 'skip'
        this.sendRoleMailAddress = uiInstruction.instructionParamJson.sendRoleMailAddress || ''
      } else {
        this.noinvoicepdf = 'skip'
        this.sendRoleMailAddress = ''
      }
      this.startChecking(invoices)
    },
    async startChecking(invoices) {
      if (invoices.length <= 1) {
        this.$message.warning(this.$t('Invoice.PleaseThanOneInvoiceMerge'))
        return
      }
      const existFileInvoices = []
      for (const invoice of invoices) {
        if (invoice.webPdfFile) {
          existFileInvoices.push(invoice)
        }
      }
      if (existFileInvoices.length === 0) {
        this.$message.warning(this.$t('Invoice.NoExistsInTheData'))
        return
      }
      if (this.sendRoleMailAddress === 'yes') {
        await checkMergeInvoiceFile()
      }
      this.checkingDialog.rowData = invoices
      this.checkingDialog.existFileInvoices = existFileInvoices
      this.checkingDialog.showNext = this.noinvoicepdf === 'skip'
      if (existFileInvoices.length < invoices.length) {
        this.checkingDialog.visible = true
      } else {
        this.continueHandle()
      }
    },
    continueHandle() {
      if (this.sendRoleMailAddress === 'yes') {
        mergeInvoiceFile(this.checkingDialog.existFileInvoices).then(res => {
          this.$message.success(this.$t('Invoice.StartingPleaseWaitForEmail'))
        })
      } else {
        submitDataByPost(URL.act.invoice.mergeInvoiceFileAndDownload, {
          sessionId: this.$store.getters.userInfo.sessionId,
          base64JsonData: Base64.encode(JSON.stringify(this.checkingDialog.existFileInvoices))
        })
      }
    }
  }
}
</script>
